/* hc-quickadd.js — 20/08/2026
   Ajout au panier depuis la page d'accueil, sans casser les offres Kaching Bundles.

   POURQUOI CE DÉTOUR. Un ajout direct en /cart/add.js depuis la home a été testé sur la boutique :
   il ajoute UNE ligne sans le cadeau de l'offre groupée. Le client arrive ensuite sur la fiche,
   voit « + Mini hachoir OFFERT », reclique, et le panier passe à TROIS lignes / 439,80 € au lieu
   de 219,90 € (le produit compté deux fois). Mesuré, reproduit.

   SOLUTION. Le bouton de la home est un simple lien vers la fiche avec ?ajouter=1. Ici, on attend
   que le bouton d'ajout natif de la fiche soit prêt (donc que Kaching ait fini de s'initialiser),
   puis on le clique UNE fois. Le produit part au panier par le chemin officiel, cadeau compris.

   SÉCURITÉS : un seul déclenchement par session et par produit, paramètre retiré de l'URL,
   abandon silencieux au bout de 6 s (le visiteur reste simplement sur la fiche). */
(function () {
  'use strict';

  function parametreAjout() {
    try {
      return new URLSearchParams(window.location.search).get('ajouter') === '1';
    } catch (e) {
      return false;
    }
  }

  if (!parametreAjout()) return;

  // on nettoie l'URL tout de suite : un rafraîchissement ne doit jamais réajouter
  var urlPropre = window.location.pathname + window.location.hash;
  try {
    window.history.replaceState({}, document.title, urlPropre);
  } catch (e) {}

  // garde-fou supplémentaire : une seule fois par produit et par session
  var cle = 'hc-quickadd:' + window.location.pathname;
  try {
    if (sessionStorage.getItem(cle)) return;
    sessionStorage.setItem(cle, '1');
  } catch (e) {}

  var SELECTEURS = [
    'button[name="add"]',
    '.shop-add-to-cart-button',
    'button.product-form__submit',
    'form[action*="/cart/add"] button[type="submit"]'
  ];

  function bouton() {
    for (var i = 0; i < SELECTEURS.length; i++) {
      var b = document.querySelector(SELECTEURS[i]);
      if (b && !b.disabled && b.offsetParent !== null) return b;
    }
    return null;
  }

  var debut = Date.now();
  var DELAI_MAX = 6000;   // au-delà, on abandonne sans rien casser
  var REPOS_KACHING = 900; // laisser l'offre groupée s'initialiser avant de cliquer

  function essayer() {
    if (Date.now() - debut > DELAI_MAX) return;

    var b = bouton();
    if (!b) {
      window.setTimeout(essayer, 200);
      return;
    }

    // le bouton est là : on laisse un court repos aux applications d'offre groupée
    window.setTimeout(function () {
      var encore = bouton();
      if (encore) encore.click();
    }, REPOS_KACHING);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', essayer);
  } else {
    essayer();
  }
})();
